<template>
  <v-card
    class="ma-auto"
    elevation="5"
    outlined
    @click="scrollTo(),setTotalReport(item)"
  >
    <v-list-item three-line>
      <v-list-item-content>
        <v-list-item-subtitle class="subtitle-1 mb-1 title">
          {{ item.title }}
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" class="highchart-help" size="25"
                >mdi-help-circle-outline</v-icon
              >
            </template>
            <span>{{ item.helpIconAnnotation }}</span>
          </v-tooltip>
        </v-list-item-subtitle>

        <CountTo
          :startVal="startVal"
          :endVal="getCardInfo(item.value)"
          :duration="1500"
          :decimals="item.decimals"
          separator=","
          class="card-info-font"
        ></CountTo>
      </v-list-item-content>

      <v-icon class="icon" size="60" :color="item.color">
        {{ item.icon }}</v-icon
      >
    </v-list-item>
  </v-card>
</template>

<script>
import CountTo from "vue-count-to";
import { mapGetters, mapMutations } from "vuex";
export default {
  props: { item: Object },
  components: { CountTo },
  data: () => ({
    startVal: 0,
  }),
  methods: {
    ...mapMutations("overview", ["setTotalReport"]),
    scrollTo() {
      this.$emit("goto", "#overviewContent");
    },
  },
  computed: {
    ...mapGetters("overview", ["getCardInfo"]),
  },
};
</script>

<style lang="css" scoped>
/* .content{
  position: relative;
  left: 2%;
  top: 2%;
} */
.title {
  /* font-weight: 1000;
  font-family: Roboto, sans-serif !important; */
  color: rgba(0, 0, 0, 0.87) !important;
}

/* 小卡片文字大小、字體 */
.card-info-font {
  font-size: 1.5rem;
  font-family: Arial, cursive, sans-serif !important;
  /* width: 0%; */
}
.highchart-help {
  position: relative;
  /* top: -20px; */
}
/* .icon {
  position: absolute;

  right: 2%;
  top: 20%;
} */
</style>
